import React from "react";
import { FormattedMessage } from "react-intl";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import alertPoppetje from '../../../../assets/images/common/alert-poppetje.svg';

const SaveSettingsChangesAlert = ({setIsMessageAlertOpen, isMessageAlertOpen, handleConfirm}) => {
   
    return (
        <Dialog 
            open={isMessageAlertOpen} 
            onClose={() => setIsMessageAlertOpen(false)}
            maxWidth={false}
            componentsProps={{
                backdrop: {
                    sx: {
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backdropFilter: 'blur(10px)',
                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    },
                },
            }}
            sx={{ 
                '& .MuiDialog-paper': { 
                    borderRadius: '30px',
                    width: '836px',
                    height: '288px', 
                    backgroundColor: '#AFC6DF',
                    boxShadow: '0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05)',
                    alignItems: 'center',
                    justifyContent: 'center',
                   
                }
            }}
        >
            <DialogContent
                sx={{
                    width: '600px',
                    textAlign: 'center',
                    color: 'black',
                    fontSize: '25px',
                    fontWeight: 'bold',
                    fontFamily: 'Altivo',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginTop: '40px',
                    marginLeft: '130px',
                }}
            >
                <Box display='flex' alignItems='center'>
                    <FormattedMessage id="teamroom.settings.unsavedChanges" />
                    <img src={alertPoppetje} alt='alert poppetje' style={{ marginLeft: '40px' }} />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button 
                    onClick={() => setIsMessageAlertOpen(false)}
                    sx={{
                        border: '2px solid white',
                        borderRadius: '27px',
                        backgroundColor: 'white',
                        width: '166px',
                        height: '50px',
                        marginBottom: '40px',
                        marginRight: '25px',
                        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',

                        '&:hover': {
                            border: 'none',
                            boxShadow: 'none',
                            color: 'black', 
                            backgroundColor: '#AFA2FF',
                        },
                        lineHeight: '2.5rem',
                        color: '#4598B1',
                        fontFamily: 'Altivo',
                        letterSpacing: '4.8px',
                        textTransform: "none",
                        }}
                >
                    <FormattedMessage id="teamroom.common.cancel" />
                </Button>
                   <Button 
                    onClick={() => {
                        handleConfirm();
                        setIsMessageAlertOpen(false);
                    }}
                    sx={{
                        border: '2px solid #4598B1',
                        borderRadius: '27px',
                        boxShadow: '0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                        marginBottom: '40px',
                        backgroundColor: '#4598B1',
                        width: '166px',
                        height: '50px',
                        '&:hover': {
                            border: 'none',
                            boxShadow: 'none',
                            color: 'black', 
                            backgroundColor: '#AFA2FF',
                        },
                        lineHeight: '2.5rem',
                        color: 'white',
                        fontFamily: 'Altivo',
                        letterSpacing: '4.8px',
                        marginRight: '10px',
                        }}
                >
                    <FormattedMessage id="teamroom.settings.ok" />
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default SaveSettingsChangesAlert;